import getLanguage from "@/app/utils/getlanguage";

import translation from "./locale/index.json";
import NavBarClient, { type NavLinkItem } from "./NavBarClient";

const normalizePath = (path: string) => {
  if (!path) return "/";
  return path.startsWith("/") ? path : `/${path}`;
};

const localizeHref = (path: string, locale: string) => {
  const normalized = normalizePath(path);
  if (normalized === "/" || normalized === `/${locale}`) return `/${locale}`;
  return `/${locale}${normalized}`;
};

interface NavBarProps {
  locale: string;
}

export default function NavBar({ locale }: NavBarProps) {
  const content = getLanguage(translation, locale);

  const navLinks: NavLinkItem[] = [
    { href: localizeHref("/", locale), label: content?.home ?? "Home" },
    // { href: localizeHref("/make-appointment", locale), label: content?.makeAppointment ?? "Umów wizytę" },
    {
      href: localizeHref("/first-visit-to-the-dentist", locale),
      label: content?.dentysta ?? "Dentysta",
    },
    { href: localizeHref("/ortodonta", locale), label: content?.ortodonta ?? "Ortodoncja" },
    { href: localizeHref("/cennik", locale), label: content?.cennik ?? "Cennik" },
    { href: localizeHref("/payment", locale), label: content?.platnosci ?? "Płatności" },
  ];

  return <NavBarClient homeHref={localizeHref("/", locale)} navLinks={navLinks} />;
}
